import { IconProps } from './types';

export function School({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5L21 8.5V10H20V9.3L12 4.87L4 9.3V10H3V8.5L12 3.5Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M6 11V19H5V10H19V19H18V11H6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M3 19H21V20H3V19Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 14V19H9V13H15V19H14V14H10Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9Z"
        fill="currentColor"
      />
    </svg>
  );
}
